export enum BootstrapAlertType {
    SUCCESS,
    INFO,
    WARNING,
    DANGER
}
